import React from 'react'

const SvgComponent = props => (
  <svg viewBox="0 0 466 495" fill="none" {...props}>
    <path
      d="M326.379 105.278c29.122 0 52.731-23.568 52.731-52.64C379.11 23.569 355.501 0 326.379 0c-29.123 0-52.731 23.567-52.731 52.639 0 29.071 23.608 52.639 52.731 52.639z"
      fill="#E4C865"
    />
    <path
      d="M326.379 112.353c29.122 0 52.731-23.567 52.731-52.639 0-29.072-23.609-52.639-52.731-52.639-29.123 0-52.731 23.567-52.731 52.639 0 29.072 23.608 52.639 52.731 52.639z"
      fill="url(#avoid-fees__paint0_linear)"
    />
    <path
      d="M326.379 104.004c24.817 0 44.935-20.083 44.935-44.856 0-24.774-20.118-44.857-44.935-44.857-24.817 0-44.935 20.083-44.935 44.857 0 24.773 20.118 44.856 44.935 44.856z"
      fill="#F78800"
    />
    <path
      d="M327.211 102.046c23.987 0 43.431-19.247 43.431-42.988 0-23.742-19.444-42.988-43.431-42.988-23.986 0-43.431 19.246-43.431 42.988 0 23.741 19.445 42.988 43.431 42.988z"
      fill="#FFE47B"
    />
    <path
      d="M294.485 81.08c6.804 10.33 18.711 17.122 32.036 17.122 21.262 0 38.556-17.263 38.556-38.488 0-8.632-2.835-16.556-7.655-22.923-17.86 25.894-42.809 38.347-62.937 44.29z"
      fill="url(#avoid-fees__paint1_linear)"
    />
    <g opacity={0.8}>
      <path
        d="M210.668 143.928c23.565 0 42.668-19.07 42.668-42.593 0-23.524-19.103-42.593-42.668-42.593-23.565 0-42.668 19.07-42.668 42.593 0 23.523 19.103 42.593 42.668 42.593z"
        fill="#E4C865"
      />
      <path
        d="M210.668 149.653c23.565 0 42.668-19.07 42.668-42.593 0-23.524-19.103-42.594-42.668-42.594-23.565 0-42.668 19.07-42.668 42.594 0 23.523 19.103 42.593 42.668 42.593z"
        fill="url(#avoid-fees__paint2_linear)"
      />
      <path
        d="M210.668 142.897c20.081 0 36.36-16.25 36.36-36.296 0-20.045-16.279-36.295-36.36-36.295s-36.36 16.25-36.36 36.295c0 20.046 16.279 36.296 36.36 36.296z"
        fill="#F78800"
      />
      <path
        d="M211.342 141.313c19.408 0 35.142-15.573 35.142-34.784 0-19.21-15.734-34.784-35.142-34.784-19.409 0-35.143 15.573-35.143 34.784s15.734 34.784 35.143 34.784z"
        fill="#FFE47B"
      />
    </g>
    <path
      d="M222.017 209.704s-15.152 7.048-22.556-4.125c-7.232-11 5.338-16.328 9.298-9.109 3.96 7.219-7.921 17.531-21.179 15.297"
      stroke="#fff"
      strokeWidth={3}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M407.8 132.703s1.894 11.344-3.96 25.438c-8.781-.86-14.808-9.969-14.808-9.969l-.86-6.704 8.953-3.437 6.371-2.235 4.304-3.093z"
      fill="#00C366"
    />
    <path
      d="M393.165 151.266l14.635-18.563s-16.013-4.985-29.615 8.422c4.649 10.484 14.98 10.141 14.98 10.141z"
      fill="url(#avoid-fees__paint3_linear)"
    />
    <path
      d="M328.08 314.379c61.43 0 111.229-41.093 111.229-91.783 0-50.691-49.799-91.784-111.229-91.784s-111.229 41.093-111.229 91.784c0 50.69 49.799 91.783 111.229 91.783z"
      fill="url(#avoid-fees__paint4_linear)"
    />
    <path
      d="M326.186 155.219c58.025 0 110.713 37.985 110.713 86.283a75.88 75.88 0 0 0 2.41-18.906c0-50.705-49.76-91.784-111.229-91.784-61.468 0-111.229 41.079-111.229 91.784 0 2.922.172 5.672.517 8.422 4.649-44.861 55.27-75.799 108.818-75.799z"
      fill="url(#avoid-fees__paint5_linear)"
      fillOpacity={0.25}
    />
    <path
      d="M431.906 202.658c-5.166 0-9.298 11.859-9.298 26.469 0 14.61 4.132 26.47 9.298 26.47H456.7v-52.939h-24.794z"
      fill="url(#avoid-fees__paint6_linear)"
    />
    <path
      d="M465.997 229.127c0 14.61-4.132 26.47-9.297 26.47-5.166 0-9.298-11.86-9.298-26.47s4.132-26.469 9.298-26.469c5.165 0 9.297 11.859 9.297 26.469zM285.379 288.253c-12.741 0-23.072 3.61-23.072 8.079v26.641c0 4.469 10.331 8.078 23.072 8.078 12.742 0 23.073-3.609 23.073-8.078v-26.641c0-4.469-10.331-8.079-23.073-8.079zM367.682 288.253c-12.741 0-23.072 3.61-23.072 8.079v26.641c0 4.469 10.331 8.078 23.072 8.078s23.072-3.609 23.072-8.078v-26.641c0-4.469-10.331-8.079-23.072-8.079z"
      fill="#D9DEDB"
    />
    <path
      d="M392.132 189.079c-7.576 0-13.775 6.188-13.775 13.75 0 1.375 1.205 2.579 2.583 2.579 1.377 0 2.583-1.204 2.583-2.579 0-4.64 3.788-8.594 8.609-8.594s8.609 3.782 8.609 8.594c0 1.375 1.205 2.579 2.582 2.579 1.378 0 2.583-1.204 2.583-2.579 0-7.562-6.198-13.75-13.774-13.75z"
      fill="#00C366"
    />
    <path
      d="M289.684 147.312c2.41-.687 16.013-5.328 51.999-4.297l7.92-6.703s-24.966-3.953-54.065 2.75l-5.854 8.25z"
      fill="#00A355"
    />
    <path
      d="M352.186 171.891h-26.172s2.066-36.782 36.503-48.642c4.132 18.735-2.239 27.329-2.239 27.329l-8.092 21.313z"
      fill="url(#avoid-fees__paint7_linear)"
    />
    <path
      d="M352.186 171.891s8.953-14.953 22.9-21.485c0 0-1.722-14.094-12.742-27.329.173.172-15.668 19.251-10.158 48.814z"
      fill="#00C366"
    />
    <path
      d="M378.013 222.596c0 5.844-4.649 10.484-10.503 10.484s-10.503-4.64-10.503-10.484 4.649-10.485 10.503-10.485 10.503 4.641 10.503 10.485z"
      fill="#00C366"
      fillOpacity={0.5}
    />
    <path
      d="M285.855 194.445c-1.193 0-2.237-1.042-2.237-2.233V88.014c0-1.19 1.044-2.233 2.237-2.233s2.237 1.042 2.237 2.233v104.198c.149 1.191-.895 2.233-2.237 2.233z"
      fill="url(#avoid-fees__paint8_linear)"
    />
    <path
      d="M339.002 211.228c-1.193 0-2.237-1.042-2.237-2.232V104.797c0-1.191 1.044-2.233 2.237-2.233s2.237 1.042 2.237 2.233v104.199c0 1.19-1.044 2.232-2.237 2.232z"
      fill="url(#avoid-fees__paint9_linear)"
    />
    <path
      d="M368.839 174.391c-1.193 0-2.237-1.042-2.237-2.233v-65.496c0-1.191 1.044-2.233 2.237-2.233s2.237 1.042 2.237 2.233v65.347c0 1.34-.895 2.382-2.237 2.382z"
      fill="url(#avoid-fees__paint10_linear)"
    />
    <path
      d="M308.233 183.566c-1.193 0-2.237-1.042-2.237-2.233v-65.347c0-1.191 1.044-2.233 2.237-2.233 1.192 0 2.236 1.042 2.236 2.233v65.347c0 1.191-.894 2.233-2.236 2.233z"
      fill="url(#avoid-fees__paint11_linear)"
    />
    <path
      d="M202.963 474.787L0 347.701l82.604-51.795 128.721 89.441 58.279 72.512-66.641 16.928z"
      fill="#00A355"
    />
    <path
      d="M374 396.211v13.643c0 .253 0 .253-.253.505l-147.725 84.388c-.507.253-1.267.253-1.774 0l-24.072-13.896c-.253-.253-.507-.253-.507-.505v-13.644l11.656 6.569L347.648 395.2c.506-.253 1.267-.253 1.773 0l8.362 4.8L374 396.211z"
      fill="url(#avoid-fees__paint12_linear)"
    />
    <path
      d="M347.648 381.557l-147.725 84.387c-.507.253-.507.758.253 1.011l24.072 13.896c.507.253 1.52.253 1.774 0l147.725-84.388c.506-.252.506-.758-.254-1.01l-24.072-13.896c-.506-.253-1.267-.253-1.773 0z"
      fill="#fff"
    />
    <path
      opacity={0.6}
      d="M342.327 402.022l-116.052 65.185c-.76-4.547-2.28-9.348-4.054-13.896l115.798-66.196c2.027 4.8 3.547 9.854 4.308 14.907z"
      fill="#00C366"
    />
    <path
      d="M352.715 389.389l-139.109 79.587c-.254.253-.254.506 0 .758l6.081 3.537c.253.253 1.014.253 1.267 0l139.11-79.587c.253-.252.253-.505 0-.758l-6.082-3.537c-.253 0-.76-.253-1.267 0z"
      fill="#007B40"
    />
    <path
      d="M360.317 393.684l-2.787 1.516-3.294-1.768c-.254-.253-1.014-.253-1.267 0l-136.576 78.071-2.787-1.516c-.254-.253-.507-.506 0-.758l139.109-79.587c.254-.253 1.014-.253 1.267 0l6.082 3.537c.506 0 .506.505.253.505z"
      fill="#00A355"
    />
    <path
      opacity={0.96}
      d="M1.774 252.196L117.572 186c0 20.718 14.443 45.984 32.433 56.343l159.635 92.472c21.031 12.128 38.261 41.941 38.008 66.196L231.85 467.208c0-24.255-16.977-53.816-38.009-66.197L34.207 308.539c-17.99-10.359-32.433-35.625-32.433-56.343z"
      fill="url(#avoid-fees__paint13_linear)"
    />
    <path
      opacity={0.8}
      d="M347.648 401.012L231.85 467.208v-3.285l115.798-66.196v3.285z"
      fill="#00C366"
    />
    <path
      opacity={0.32}
      d="M178.159 350.238l-26.353 14.907 2.534 1.516 26.099-14.907-2.28-1.516zM191.588 342.405l-9.629 5.559 2.534 1.516 9.629-5.559-2.534-1.516zM201.977 336.594l-6.588 3.538 2.534 1.516 6.588-3.538-2.534-1.516zM160.421 353.775l-14.443 8.085 2.534 1.516 14.443-8.338-2.534-1.263zM181.959 341.395l-17.737 10.106 2.534 1.263 17.737-9.853-2.534-1.516zM192.348 335.331l-6.588 3.79 2.534 1.516 6.588-3.79-2.534-1.516zM202.23 329.772l-6.334 3.538 2.534 1.516 6.334-3.538-2.534-1.516zM150.539 352.511l-10.389 6.064 2.534 1.516 10.389-6.064-2.534-1.516zM158.141 348.216l-3.548 2.022 2.534 1.516 3.548-2.022-2.534-1.516zM168.53 342.405l-6.335 3.537 2.534 1.516 6.335-3.789-2.534-1.264zM172.584 333.31l-38.008 21.981 2.534 1.263 38.008-21.728-2.534-1.516zM186.014 325.73l-9.376 5.306 2.534 1.516 9.375-5.559-2.533-1.263zM139.137 345.943l-10.389 5.811 2.534 1.516 10.389-5.811-2.534-1.516zM163.462 332.046l-20.271 11.623 2.534 1.516 20.271-11.623-2.534-1.516zM173.851 325.982l-6.588 3.79 2.534 1.516 6.588-3.79-2.534-1.516zM144.205 336.342l-21.285 12.127 2.534 1.516 21.284-12.128-2.533-1.515zM163.462 325.477l-15.203 8.591 2.534 1.516 15.203-8.843-2.534-1.264zM177.905 317.139l-10.389 5.812 2.534 1.515 10.389-5.811-2.534-1.516zM124.44 341.142l-7.348 4.042 2.534 1.516 7.348-4.042-2.534-1.516zM137.87 333.31l-9.629 5.558 2.534 1.264 9.629-5.306-2.534-1.516zM157.127 322.445l-15.203 8.591 2.534 1.516 15.203-8.591-2.534-1.516zM133.309 329.267L111.518 341.9l2.533 1.516 21.792-12.633-2.534-1.516zM157.888 315.371l-20.525 11.622 2.534 1.516 20.524-11.875-2.533-1.263zM168.276 309.307l-6.334 3.79 2.534 1.264 6.334-3.538-2.534-1.516zM178.412 303.496l-6.588 3.79 2.534 1.516 6.334-3.79-2.28-1.516zM118.866 331.036l-13.176 7.579 2.534 1.264 13.176-7.327-2.534-1.516zM231.117 319.666l18.243-10.359 2.534 1.516-18.244 10.359-2.533-1.516zM229.343 314.108l14.443-8.085 2.28 1.516-14.189 8.085-2.534-1.516zM227.569 308.549l10.389-5.811 2.534 1.516-10.389 5.811-2.534-1.516zM217.18 308.044l14.95-8.591 2.534 1.264-14.95 8.59-2.534-1.263zM215.913 301.98l10.389-6.063 2.534 1.515-10.389 6.064-2.534-1.516zM207.551 300.212l13.177-7.58 2.28 1.516-12.923 7.58-2.534-1.516zM207.805 293.39l7.095-4.043 2.534 1.516-7.095 4.043-2.534-1.516zM195.136 293.895l13.936-7.832 2.534 1.263-13.937 8.085-2.533-1.516zM190.321 290.105l12.923-7.58 2.534 1.516-13.176 7.58-2.281-1.516zM128.495 325.477l-5.575 3.285 2.534 1.516 5.574-3.285-2.533-1.516zM144.965 316.129l-12.67 7.074 2.534 1.516 12.67-7.327-2.534-1.263zM129.255 290.358l-21.285 12.127 2.534 1.516 21.285-12.127-2.534-1.516zM143.698 282.02l-8.362 4.801 2.534 1.516 8.362-4.801-2.534-1.516z"
      fill="#00C366"
    />
    <defs>
      <linearGradient
        id="avoid-fees__paint0_linear"
        x1={273.614}
        y1={59.712}
        x2={378.972}
        y2={59.712}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF691" />
        <stop offset={1} stopColor="#FFCC5E" />
      </linearGradient>
      <linearGradient
        id="avoid-fees__paint1_linear"
        x1={329.811}
        y1={97.9}
        x2={329.811}
        y2={30.647}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCE6BB" stopOpacity={0} />
        <stop offset={0.187} stopColor="#FCF6E7" stopOpacity={0.187} />
        <stop offset={0.507} stopColor="#FFF4C4" stopOpacity={0.507} />
        <stop offset={0.771} stopColor="#FFF3C2" />
        <stop offset={1} stopColor="#FFFCE1" />
      </linearGradient>
      <linearGradient
        id="avoid-fees__paint2_linear"
        x1={167.973}
        y1={107.058}
        x2={253.224}
        y2={107.058}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF691" />
        <stop offset={1} stopColor="#FFCC5E" />
      </linearGradient>
      <linearGradient
        id="avoid-fees__paint3_linear"
        x1={392.993}
        y1={154.932}
        x2={392.993}
        y2={135.462}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.001} stopColor="#9C9C9C" />
        <stop offset={0.108} stopColor="#D8D8D8" />
        <stop offset={0.324} stopColor="#DFDFDF" />
        <stop offset={0.528} stopColor="#EEE" />
        <stop offset={0.715} stopColor="#fff" />
        <stop offset={0.878} stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="avoid-fees__paint4_linear"
        x1={328.132}
        y1={313.176}
        x2={328.132}
        y2={112.595}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.001} stopColor="#B3B3B3" />
        <stop offset={0.108} stopColor="#D8DDDB" />
        <stop offset={0.324} stopColor="#EAFFF5" />
        <stop offset={0.528} stopColor="#fff" />
        <stop offset={0.715} stopColor="#fff" />
        <stop offset={0.878} stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="avoid-fees__paint5_linear"
        x1={294.517}
        y1={283.792}
        x2={417.002}
        y2={51.005}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.874} stopColor="#00C366" />
        <stop offset={1} stopColor="#FFFF13" />
      </linearGradient>
      <linearGradient
        id="avoid-fees__paint6_linear"
        x1={439.662}
        y1={255.25}
        x2={439.662}
        y2={197.404}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.001} stopColor="#B3B3B3" />
        <stop offset={0.108} stopColor="#D8DDDB" />
        <stop offset={0.324} stopColor="#EAFFF5" />
        <stop offset={0.528} stopColor="#fff" />
        <stop offset={0.715} stopColor="#fff" />
        <stop offset={0.878} stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="avoid-fees__paint7_linear"
        x1={344.964}
        y1={181.048}
        x2={344.964}
        y2={132.408}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.001} stopColor="#9C9C9C" />
        <stop offset={0.108} stopColor="#D8D8D8" />
        <stop offset={0.324} stopColor="#DFDFDF" />
        <stop offset={0.528} stopColor="#EEE" />
        <stop offset={0.715} stopColor="#fff" />
        <stop offset={0.878} stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="avoid-fees__paint8_linear"
        x1={285.883}
        y1={194.442}
        x2={285.883}
        y2={85.651}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.283} stopColor="#FBFBFB" stopOpacity={0.283} />
        <stop offset={0.765} stopColor="#FFE47B" />
        <stop offset={1} stopColor="#FFE47B" />
      </linearGradient>
      <linearGradient
        id="avoid-fees__paint9_linear"
        x1={339.023}
        y1={211.225}
        x2={339.023}
        y2={102.434}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.283} stopColor="#FBFBFB" stopOpacity={0.283} />
        <stop offset={0.765} stopColor="#FFE47B" />
        <stop offset={1} stopColor="#FFE47B" />
      </linearGradient>
      <linearGradient
        id="avoid-fees__paint10_linear"
        x1={368.86}
        y1={174.389}
        x2={368.86}
        y2={104.345}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.283} stopColor="#FBFBFB" stopOpacity={0.283} />
        <stop offset={0.765} stopColor="#FFE47B" />
        <stop offset={1} stopColor="#FFE47B" />
      </linearGradient>
      <linearGradient
        id="avoid-fees__paint11_linear"
        x1={308.253}
        y1={183.564}
        x2={308.253}
        y2={113.67}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.283} stopColor="#FBFBFB" stopOpacity={0.283} />
        <stop offset={0.765} stopColor="#FFE47B" />
        <stop offset={1} stopColor="#FFE47B" />
      </linearGradient>
      <linearGradient
        id="avoid-fees__paint12_linear"
        x1={193.362}
        y1={443.232}
        x2={353.97}
        y2={446.342}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00CE6C" />
        <stop offset={0.04} stopColor="#00CD6B" />
        <stop offset={0.087} stopColor="#00D06D" />
        <stop offset={0.137} stopColor="#00D06D" />
        <stop offset={0.19} stopColor="#35D086" />
        <stop offset={0.224} stopColor="#0FD778" />
      </linearGradient>
      <linearGradient
        id="avoid-fees__paint13_linear"
        x1={94.119}
        y1={188.102}
        x2={260.929}
        y2={473.141}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EDFFF6" />
        <stop offset={0.117} stopColor="#D7D7D7" />
        <stop offset={0.263} stopColor="#ECECEC" />
        <stop offset={0.514} stopColor="#F0F0F0" />
        <stop offset={0.622} stopColor="#F0F4F2" />
        <stop offset={0.755} stopColor="#F4FFFA" />
        <stop offset={1} stopColor="#C5C5C5" />
      </linearGradient>
    </defs>
  </svg>
)

export default SvgComponent
